import { genesTranslate } from "../../i18n/translatedMessages";
import { useIntl } from "react-intl";
import { HiComputerDesktop } from "react-icons/hi2";

const Genes = () => {
	const language = useIntl();
	const getLanguage = language.locale === "PT-BR" ? "pt" : "es";

	return (
		<div className="conteiner-fluid sideMenuSeparator">
			<div className="row mb-4">
				<div className="col">
					<div className="flex align-items-center">
						<span className="rounded-circle text-white px-3 py-4" style={{ background: "#41C8FF" }}>
							<HiComputerDesktop size={35} />
						</span>
						<span className="fs-1 ms-3">MyDNA Outplacement</span>
					</div>
				</div>
			</div>
			<div className="row d-flex align-items-center">
				<div className="col w-100 ">
					<h4 className="mt-5 mb-4">
						<strong>{genesTranslate.genesDesc}</strong>
					</h4>
					<div>
						<p>{genesTranslate.genesText1}</p>

						<div className="d-flex flex-row ">
							<div className="col">
								<p className="ms-4 mt-4">
									<strong>{genesTranslate.genesText2}</strong>
								</p>
								<p className="ms-4 mt-4">
									<strong>{genesTranslate.genesText3}</strong>
								</p>
							</div>
							<div className="col mt-5 ms-5">
								<div className="ratio ratio-16x9">
									{getLanguage === "es" && (
										<iframe
											width="560"
											height="315"
											src="https://www.youtube.com/embed/g8yjFzovEtA"
											title="YouTube video player"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
										></iframe>
									)}
									{getLanguage === "pt" && (
										<iframe
											width="560"
											height="315"
											src="https://www.youtube.com/embed/bhwl0JGAvpA"
											title="YouTube video player"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
										></iframe>
									)}
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div className="smtm-button">
								<a href="https://outplacement.develop.mydnadigital.com/" target="_blank" rel="noopener noreferrer">
									<button
										className="btn rounded-pill my-3"
										style={{
											backgroundColor: "#7A6BE8",
											color: "white",
											width: "200px",
										}}
									>
										{genesTranslate.genesBtn}
									</button>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div className="col"></div>
			</div>
		</div>
	);
};

export default Genes;
